module.exports = __webpack_public_path__ + "static/add_csv_mapping-11693b526d536b093ec5a914e82539c3.png";